export default __webpack_public_path__ + "static/media/emptyResults.6a902f7d.svg";